// @flow
import * as React from 'react';
import glamorous from 'glamorous';

type Props = {
  label: string,
  children: React.Node,
};

const Label = glamorous.span(({ theme }) => ({
  color: theme.color.basis3,
  fontSize: theme.fontSize.small,
  paddingRight: theme.spacing.xsmall,
}));
function LabelValue({ label, children }: Props) {
  return (
    <div>
      <Label>{label}</Label>
      {children}
    </div>
  );
}

export default LabelValue;
